import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {InvoiceService} from '../services/invoice.service';

@Component({
  selector: 'to-generate-default-redirect',
  template: '',
})
export class ToGenerateDefaultRedirectComponent implements OnInit {
  constructor(
    private invoiceService: InvoiceService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.invoiceService.hasDepositedElectronicInvoice().subscribe({
      next: hasDeposited => {
        this.router.navigate(
          ['/accounting/to-generate', hasDeposited ? 'electronic' : 'classic'],
          {replaceUrl: true}
        );
      },
      error: () => {
        this.router.navigate(['/accounting/to-generate', 'classic'], {replaceUrl: true});
      }
    });
  }
}
